import React from "react";
import { useEffect, useState, useRef } from "react";
import Storage from "@/app/core/util/Storage";
import { DateTranslate, OnlyDateTranslate } from "@/app/core/util/DateTranslater";
import OnDataChange from "@/app/core/util/helpers/HandleChange";
import { toast } from "react-toastify";
import { TotalExpressController } from "@/app/core/base/controllers/TotalExpressController";
import { CalculoICMS, MoneyMask } from "@/app/core/util/helpers/MoneyHelper";
import { ShipSmartController } from "@/app/core/base/controllers/ShipSmartController";
import { FieldTypeObj } from "@/app/core/util/helpers/FieldTypeHelper";
import AddressStep from "./components/AddressStep";
import BoxesStep from "./components/BoxesStep";
import QuotationStep from "./components/QuotationStep";
import ConfirmationStep from "./components/ConfirmationStep";
import { ServiceNameController } from "@/app/core/base/controllers/ServiceNameController";
import { ICMSController } from "@/app/core/base/controllers/ICMSController";
import { CorreiosController } from "@/app/core/base/controllers/CorreiosController";
import { PartnerHelper } from "@/app/core/util/helpers/PartnerHelper";
import { ProfitController } from "@/app/core/base/controllers/ProfitController";
import Translate, { Message } from "@/app/core/util/messages/GeralMessages";
import { AddressBookController } from "@/app/core/base/controllers/AddressBookController";
import { DeliveryController } from "@/app/core/base/controllers/DeliveryController";
import { CustomMarginController } from "@/app/core/base/controllers/CustomMarginControlle";
import { HandleErrors } from "@/app/core/util/helpers/ErrorHelper";

export default function Quotation(props) {
    const [step, setStep] = useState(1);
    const userData = Storage.getUserData();
    const date = new Date();
    const [data, setData] = useState({

    });
    const [responsibles, setResponsibles] = useState({});
    const [national, setNational] = useState([]);
    const [addressBook, setAddressBook] = useState([]);
    const [nationalCarrier, setNationalCarrier] = useState({});
    const [internationalCarrier, setInternationalCarrier] = useState({});
    const [loading, setLoading] = useState(false);
    const [international, setInternational] = useState({});
    const [ICMS, setICMS] = useState([]);
    const [profit, setProfit] = useState([]);
    const [correiosServices, setCorreiosServices] = useState([]);
    const [names, setNames] = useState([]);
    const [quotation, setQuotation] = useState({
        // channel_code: 2,
        type: "simple",
        tax: "sender",
        object: "doc",
        insurance: true,
        currency_quote: "BRL",
        currency_payment: "BRL",
    });

    useEffect(() => {
        loadICMS();
        loadProfit();
        loadServiceNames();
        // setData({
        //     origin: {
        //         "name": "Fabio Rodrigues",
        //         "street": "R. Farroupilha",
        //         "city": "Vargem Grande Paulista",
        //         "state": "SP",
        //         "state_code": "SP",
        //         "country": "BR",
        //         "zipCode": "06730000",
        //         "postal_code": "06730000",
        //         "number": "12",
        //         "complement": "",
        //         "document": "43060160805",
        //         "email": "fabiorsilvajr@gmail.com",
        //         "phone": "91315267",
        //         "phoneExtension": "",
        //         "personType": 0,
        //         "address": "R. Farroupilha, Parque Santo Afonso, Vargem Grande Paulista - SP - BR - 06730-000",
        //         "country_code": "BR",
        //         "neighborhood": "BR",
        //         // "address_code": 72,
        //     },
        //     destination: {
        //         "neighborhood": "BR",
        //         "name": "Fabio Rodrigues",
        //         "street": "5th Ave",
        //         "city": "New York County",
        //         "state": "RJ",
        //         "state_code": "RJ",
        //         "country": "BR",
        //         "zipCode": "06160180",
        //         "postal_code": "06160180",
        //         "number": "12",
        //         "complement": "",
        //         "document": "43060160805",
        //         "email": "fabiorsilvajr@gmail.com",
        //         "phone": "91315267",
        //         "phoneExtension": "",
        //         "personType": 0,
        //         "address": "Joaquim felix ribeiro",
        //         "country_code": "BR"
        //     },
        //     boxes: [{
        //         "id": 1,
        //         "name": "Bolsas",
        //         "height": 10,
        //         "width": 20,
        //         "depth": 30,
        //         "weight": 1,
        //         "price": 250,
        //         "itens": []
        //     }]
        // });

        // setResponsibles({
        //     collect: {
        //         name: "Fabio Rodrigues",
        //         responsibleName: "Fabio Rodrigues",
        //         email: "fabiorsilvajr@gmail.com",
        //         phone: "991315267",
        //         document: "43060160805",
        //     },
        //     delivery: {
        //         name: "Fabio Rodrigues",
        //         responsibleName: "Fabio Rodrigues",
        //         email: "fabiorsilvajr@gmail.com",
        //         phone: "991315267",
        //         document: "43060160805",
        //     }
        // })
        loadAddressBook()
        loadDelivery()
    }, []);

    function loadDelivery() {
        if (props != undefined && props.location != undefined) {

            let param = props.location.search;
            let deliveryId = "";
            if (param.split("?")[1] !== undefined) {

                let item = param.split("?")[1].split("&"),
                    returnBool = false;
                for (var i = 0; i < item.length; i++) {
                    let parr = item[i].split("=");
                    if (parr[0] == "deliveryId" && parr[0] != undefined) {
                        deliveryId = decodeURIComponent(parr[1]);
                    }
                }


                console.log("O que pegou", deliveryId)
                let infos = data;
                if (deliveryId != undefined && deliveryId != null) {
                    DeliveryController.GetOne(deliveryId, res => {
                        res.origin.country_code = res.origin.country;
                        res.destination.country_code = res.destination.country;
                        res.origin.address = `${res.origin.number}, ${res.origin.street}, ${res.origin.neighborhood} | ${res.origin.city} - ${res.origin.state}`;
                        res.destination.address = `${res.destination.number}, ${res.destination.street}, ${res.origin.neighborhood} | ${res.origin.city} - ${res.origin.state}`;

                        for (let s in res.boxes) {
                            res.boxes[s].id = parseInt(s) + 1;
                        }
                        console.log("Retorno", res);

                        setData(res);
                        let responsible = {
                            collect: res.origin,
                            delivery: res.destination,
                        };
                        setResponsibles(responsible);
                    })
                }
            }
        }
    }

    function loadAddressBook() {
        AddressBookController.Get(res => setAddressBook(res))
    }

    function loadICMS() {
        ICMSController.List(res => setICMS(res))
    }

    function loadProfit() {
        ProfitController.List(async (res) => {
            let list = [];
            for (let s in res) {
                list.push(res[s]);
            }

            await CustomMarginController.ByUser(userData.id, result => {
                for (let s in result) {
                    list.push(result[s]);
                }
            })

            if (userData.companyId) {
                await CustomMarginController.ByCompany(userData.companyId, result => {
                    for (let s in result) {
                        list.push(result[s]);
                    }
                })
            }

            console.log("Margens", list);

            setProfit(list);
        })
    }

    function loadServiceNames() {
        ServiceNameController.List(res => setNames(res))
    }

    function handleQuotationChange(evt, type) {
        if (evt.target.value == "doc" || evt.target.value == "not_doc") {
            if (data.origin == data.destination && data.destination == "BR") {
                setQuotation({
                    ...quotation,
                    [evt.target.name]: evt.target.value,
                    type: "simple",
                })
            } else {
                setQuotation({
                    ...quotation,
                    [evt.target.name]: evt.target.value,
                    type: evt.target.value == "doc" ? "simple" : "advanced",
                })
            }
        } else {
            setQuotation(OnDataChange(quotation, evt, type));
        }
    }

    function getQuotation(theData) {
        let base = theData;
        console.log("Resultado", base);
        setNational([]);
        setInternational([]);
        setLoading(true)
        if (base.origin.country_code == "BR" && base.destination.country_code == "BR") {
            // TotalExpress - Entrega nacional
            getNationalQuotation(base)
        } else {
            // ShipSmart - Entrega internacional
            base.origin.state_code = base.origin.state;
            base.destination.state_code = base.destination.state;
            getInternationalQuotation(base)
        }
    }

    async function getNationalQuotation(baseQuotation) {
        let message = "Faltou preencher ";
        let error = false;
        let box = baseQuotation.boxes[0];
        box.declaredValue = box.price;
        if (box.height == undefined || box.height == "") {
            error = true;
            message += " Altura;"
        }
        if (box.width == undefined || box.width == "") {
            error = true;
            message += " largura;"
        }
        if (box.depth == undefined || box.depth == "") {
            error = true;
            message += " profundidade;"
        }
        if (box.weight == undefined || box.weight == "") {
            error = true;
            message += " peso;"
        }
        if (box.declaredValue == undefined || box.declaredValue == "") {
            error = true;
            message += " valor do conteúdo";
        }

        if (error) {
            toast.error(message);
        } else {
            let base = {};

            base.declaredValue = box.declaredValue;
            base.depth = box.depth;
            base.height = box.height;
            base.width = box.width;
            base.weight = box.weight;
            base.zipCode = data.destination.zipCode.replace(/\D/g, "");
            base.state = data.destination.state;
            const tax = ICMS.filter(x => x.originState == data.origin.state && data.destination.state == x.destinationState);

            TotalExpressController.Quotation(base, async res => {
                console.log("Calculo de frete", res);
                const today = new Date();
                const delivery = new Date(today.setDate(today.getDate() + res.deadline));

                const base = CalculoICMS(tax[0], res.beforeTaxes);
                res.totalPrice = base.total;
                res.taxCost = base.taxCost;

                console.log("Resultado ICMS", base, res);

                let nationalName = names.filter(x => x.partner == 2);

                if (nationalName.length > 0) {
                    res.name = nationalName[0].name;
                } else {
                    res.name = "Total Express";
                }

                res.deliveryDate = OnlyDateTranslate(delivery);
                if (date.getHours() > 10) {
                    res.collectDate = "Coleta: Amanhã entre as 12 e 18h";
                } else {
                    res.collectDate = "Coleta: Hoje até as 18h";
                }

                let results = []
                res.partner = PartnerHelper.Partner.TotalExpress;
                if (data.origin.address.includes("GRU") || data.origin.address.includes("Aeroporto Internacional") || data.origin.address.includes("hélio schmidt"))
                    results.push(res);

                let correiosQuotation = [];

                let parametrosProduto = [];
                for (let s in baseQuotation.boxes) {
                    const item = baseQuotation.boxes[s];
                    let baseCorreios = CorreiosController.BaseQuotation.parametrosProduto;

                    baseCorreios.comprimento = `${item.depth}`;
                    baseCorreios.altura = `${item.height}`;
                    baseCorreios.largura = `${item.width}`;
                    baseCorreios.psObjeto = `${item.weight}`;
                    baseCorreios.cepOrigem = data.origin.zipCode;
                    baseCorreios.cepDestino = data.destination.zipCode;

                    parametrosProduto.push(baseCorreios);
                    console.log("parametros produto", baseCorreios);
                }
                for (let s in correiosServices) {
                    let service = correiosServices[s];

                    let produto = [];

                    for (let p in parametrosProduto) {
                        parametrosProduto[p].coProduto = service.codigo;
                        produto.push(parametrosProduto[p]);
                    }

                    await CorreiosController.Quotation({ idLote: "sdklcsldc", parametrosProduto: produto }, result => {

                        let component = result[0];
                        if (component.pcFinal != "0.00") {


                            const margin = profit.filter(x => x.isDefault == true || x.country == "BR" || x.isDefault == undefined);

                            component.name = service.descricao;
                            component.collectDate = undefined;
                            component.deliveryDate = undefined;

                            component.taxCost = parseFloat(component.vlBaseCalculoImposto) - parseFloat(component.pcBase);

                            component.beforeTaxes = parseFloat(component.pcFinal);


                            let pretotal = parseFloat(component.pcFinal) + (margin[0].value * parseFloat(component.pcFinal));
                            console.log(`Quase Resultado ICMS ${pretotal}`, margin[0].value * parseFloat(component.pcFinal), margin[0].value, component.pcFinal);

                            component.total = pretotal;
                            const base = CalculoICMS(tax[0], pretotal);
                            component.totalPrice = base.total;
                            component.taxCost = base.taxCost;

                            component.freight = pretotal;
                            component.insurance = parseFloat(component.peAdValorem);
                            component.serviceValue = parseFloat(component.vlSeguroAutomatico);


                            let nationalName = names.filter(x => x.oldName == component.name);

                            if (nationalName.length > 0) {
                                component.name = nationalName[0].name;
                            }
                            results.push({ ...component, partner: PartnerHelper.Partner.Correios })

                            setNational(results);
                        }
                    }, error => console.log("Resultado", error));

                    console.log("Correios Quotation", correiosQuotation, produto);
                }
                setLoading(false)
                setNational(results);
                setStep(3);

            });


        }
    }

    function getInternationalQuotation(old) {
        let message = "Faltou preencher ";
        let error = false;
        const boxes = old.boxes;
        if (boxes.length == 0) {
            error = true;
            message += " Cadastrar ao menos uma caixa;"
        }

        if (error) {
            toast.error(message);
        } else {
            let items = [];
            for (let s in boxes) {
                if (boxes[s].items) {
                    items = [...items, ...boxes[s].items]
                }
            }
            let base = {
                ...quotation,
                address_sender: {
                    country_code: data.origin.country,
                    postal_code: data.origin.zipCode,
                    ...data.origin,
                },
                address_receiver: {
                    country_code: data.destination.country,
                    ...data.destination,
                },
                boxes,
                items,
            };

            if (data.origin.postal_town) {
                base.address_sender = data.origin.postal_town;
            }

            if (data.destination.postal_town) {
                base.address_receiver = data.destination.postal_town;
            }

            // address_code: 72,

            ShipSmartController.Quotation(base, res => {
                console.log("Resultado", res.data);
                if (res.data) {
                    for (let s in res.data.carriers) {
                        let item = res.data.carriers[s];
                        let margin = getMargin();

                        let exist = names.filter(x => x.oldName == item.name);
                        if (exist.length > 0) {
                            res.data.carriers[s].name = exist[0].name;
                        }
                        res.data.carriers[s].freight_final = parseFloat(res.data.carriers[s].freight_final) + (parseFloat(res.data.carriers[s].freight_final) * margin);
                        res.data.carriers[s].currency_quote_price = parseFloat(res.data.carriers[s].currency_quote_price) + (parseFloat(res.data.carriers[s].currency_quote_price) * margin);
                        res.data.carriers[s].currency_payment_amount = parseFloat(res.data.carriers[s].currency_payment_amount) + (parseFloat(res.data.carriers[s].currency_payment_amount) * margin);
                        res.data.carriers[s].insurance = parseFloat(res.data.carriers[s].insurance) + (parseFloat(res.data.carriers[s].insurance) * margin);
                        res.data.carriers[s].insurance_final = parseFloat(res.data.carriers[s].insurance_final) + (parseFloat(res.data.carriers[s].insurance_final) * margin);
                    }
                }
                setInternational(res.data);
                setLoading(false)
                setStep(3);
            }, error => {
                if (error && error.response && error.response.data && error.response.data) {
                    for (let s in error.response.data) {
                        const item = error.response.data[s];
                        console.log("tratamento", item);
                        toast.error(item[0].message);
                    }
                } else {
                    toast.error(HandleErrors(error));
                }
            })
        }
    }

    function getMargin() {
        let value = 0;

        for (let s in profit) {
            let item = profit[s];
            if (item.isDefault == true) {
                value += item.value;
            }
            if (item.isDefault == undefined) {
                value += item.value;
            }
        }

        console.log("Margem total", value);

        return value;
    }

    function reportAddresses(address) {
        setData({ ...data, ...address })
        setStep(step + 1);
        if (address.origin.country_code == "BR" && address.destination.country_code == "BR") {
            loadCorreiosService()
        }

        console.log("Reported Address", address);
    }

    function loadCorreiosService() {
        CorreiosController.Servicos(res => {
            if (res.itens != undefined && res.itens.length > 0) {
                setCorreiosServices(res.itens.filter(x => x.descSegmento == "ENCOMENDA"));
            }
        })
    }

    function reportBoxes(boxes) {
        setData({ ...data, boxes })
        console.log("Caixas", boxes);
        setStep(step + 1);
        getQuotation({ ...data, boxes });
    }

    function selectedNational(selected) {
        const today = new Date();
        const delivery = new Date(today.setDate(today.getDate() + selected.deadline));

        selected.deliveryDate = DateTranslate(delivery);
        if (date.getHours() > 10) {
            selected.collectDate = "Coleta: Amanhã entre as 12 e 18h";
        } else {
            selected.collectDate = "Coleta: Hoje até as 18h";
        }
        setNationalCarrier(selected);
        setStep(step + 1)
    }

    function selectedInternational(selected) {
        setInternationalCarrier(selected);
        setStep(step + 1)
    }

    function reportOriginResponsible(item) {
        setResponsibles({ ...responsibles, collect: item });
    }

    function reportDestinationResponsible(item) {
        setResponsibles({ ...responsibles, delivery: item });
    }

    function handleStep() {
        switch (step) {
            case 1:
                return (
                    <div className="row p-2">
                        <div className="col-md-12">
                            <AddressStep
                                infos={data}
                                addressBook={addressBook}
                                reportOriginResponsible={item => reportOriginResponsible(item)}
                                reportDestinationResponsible={item => reportDestinationResponsible(item)}
                                reportAddresses={address => reportAddresses(address)} />
                        </div>
                    </div>
                )
            case 2:
                return (
                    <div>
                        <div className="row">
                            <div className="block block-rounded block-bordered block-fx-pop ml-0 mr-0 border-info col-md-12">
                                <div className="block-header">
                                    <div className="block-title"><i className="fa fa-book mr-2 text-info" /> {Translate(Message.CustomsDefinitions)}</div>
                                </div>
                                <div className="ml-2 mr-2 mb-3">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <span>{Translate(Message.Insurance)}</span>
                                            <select className="form-control" name="insurance" value={quotation && quotation.insurance} onChange={evt => handleQuotationChange(evt, FieldTypeObj.Bool)}>
                                                <option>{Translate(Message.Select)}</option>
                                                <option value={true}>{Translate(Message.Yes)}</option>
                                                <option value={false}>{Translate(Message.No)}</option>
                                            </select>
                                        </div>
                                        <div className="col-md-4">
                                            <span>{Translate(Message.WhosGonaPaysTaxes)}</span>
                                            <select className="form-control" name="tax" value={quotation && quotation.tax} onChange={evt => handleQuotationChange(evt)}>
                                                <option>{Translate(Message.Select)}</option>
                                                <option value={"sender"}>{Translate(Message.Sender)}</option>
                                                <option value={"receiver"}>{Translate(Message.Recipient)}</option>
                                            </select>
                                        </div>
                                        <div className="col-md-4">
                                            <span>{Translate(Message.ProductType)}</span>
                                            <select className="form-control" name="object" value={quotation && quotation.object} onChange={evt => handleQuotationChange(evt)}>
                                                <option>{Translate(Message.Select)}</option>
                                                <option value={"doc"}>Documento</option>
                                                <option value={"not_doc"}>Produto</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {quotation && <BoxesStep reportBoxes={boxes => reportBoxes(boxes)} infos={data} goBack={() => setStep(step - 1)} quotation={quotation && quotation} />}
                    </div>
                )
            case 3:
                return (
                    <div className="col-12 row p-2">
                        {loading === true ? (
                            <div className="block-content text-center">
                                <i className={"fa fa-circle-notch fa-spin"}></i>
                            </div>
                        ) : ""}
                        <QuotationStep
                            infos={data}
                            international={international}
                            national={national}
                            goBack={() => setStep(step - 1)}
                            selectedNational={selected => selectedNational(selected)}
                            selectedInternational={selected => selectedInternational(selected)} />
                    </div>
                )
            case 4:
                return (
                    <div className="col-12 row">
                        <ConfirmationStep
                            infos={data}
                            back={() => setStep(step - 1)}
                            end={() => setStep(step + 1)}
                            nationalCarrier={nationalCarrier}
                            internationalCarrier={internationalCarrier}
                            reportResponsibles={infos => setResponsibles(infos)}
                            responsibles={responsibles}
                            quotation={quotation}
                            reportItens={itens => setData({ ...data, ...itens })} />
                    </div>
                )
            case 5:
                return (
                    <div className="text-center">
                        <i className="si si-check fa-2x text-succcess" />
                        <br />
                        <h3 className="text-muted py-5">Seu pedido foi finalizado!<br /> A documentação sendo emitida</h3>

                        <div className="block block-bordered">
                            <button type="button" className="btn btn-hero-lg btn-hero-success mt-3" onClick={() => setStep(1)}>
                                Voltar ao início
                            </button>
                        </div>
                    </div>
                )
        }
    }

    return (
        <div className="content">
            <div className="">
                <h3 className="text-muted"><i className="fa fa-arrow-left mr-1" /> {Translate(Message.Menu.Quotation)}</h3>
            </div>

            {step && handleStep()}
        </div>
    )
}